(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const drawer = document.querySelector('[data-menu-drawer]');
    const openButton = document.querySelector('[data-menu-open]');
    const closeButton = document.querySelector('[data-menu-close]');
    if (!drawer || !openButton || !closeButton) return;

    openButton.addEventListener('click', () => drawer.showModal());
    closeButton.addEventListener('click', () => drawer.close());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-images"] && !Shopify.designMode) return;
  try {
    
(() => {
const track = document.querySelector('[data-top-images-track]');
if (!track) return;

// 末尾に1枚目のクローンを足してシームレスにループさせる
const slideCount = track.children.length;
const firstClone = track.children[0].cloneNode(true);
firstClone.setAttribute('aria-hidden', 'true');
track.appendChild(firstClone);

// 表示中のスライド番号(1始まり)をbodyに公開する（ヘッダーがスライドに応じて色を変えるために参照）
const setSlideState = (i) => {
document.body.setAttribute('data-top-images-slide', (i % slideCount) + 1);
};
setSlideState(0);

let index = 0;
setInterval(() => {
if (document.hidden || index === slideCount) return;
index += 1;
setSlideState(index);
track.style.transition = 'transform 0.6s ease';
track.style.transform = `translateX(-${index * 100}%)`;
if (index === slideCount) {
// クローン（1枚目の複製）に到達したら、アニメーション完了後に無効果で先頭へ戻す
setTimeout(() => {
track.style.transition = 'none';
track.style.transform = 'translateX(0)';
index = 0;
}, 650);
}
}, 4000);
})();

// フッターが画面下端の手前まで来たら body に属性を付け、購入ボタンを隠す（CSS側で参照）
(() => {
const footer = document.querySelector('.shopify-section-group-footer-group');
if (!footer || !('IntersectionObserver' in window)) return;

const observer = new IntersectionObserver(
([entry]) => {
document.body.toggleAttribute('data-top-images-near-footer', entry.isIntersecting);
},
// 下方向に80px広げた範囲で判定し、フッターが見える少し手前で消し始める
{ rootMargin: '0px 0px 80px 0px' }
);
observer.observe(footer);
})();

  } catch(e) { console.error(e); }
})();
})();
